import { AmbientLight, DirectionalLight, Group } from "three";
import type { Entity } from "../types/entity";
import type { QualitySettings } from "../types/quality";

/**
 * Éclairage minimal, fonctionnel et non esthétique : sans lumière directionnelle
 * les prismes seraient uniformément plats et le relief illisible. Le parti pris
 * visuel n'est pas tranché (voir docs/open-questions.md).
 */
export class Environment implements Entity {
  readonly name = "environment";
  readonly object3D = new Group();

  private readonly sun: DirectionalLight;
  private readonly ambient: AmbientLight;

  constructor(settings: QualitySettings) {
    this.object3D.name = this.name;

    // Rasante et de biais : c'est l'inclinaison qui creuse le relief. À la
    // verticale, toutes les faces supérieures recevraient la même lumière.
    this.sun = new DirectionalLight(0xfff2e0, 2.1);
    this.sun.position.set(-18, 26, 14);
    this.sun.castShadow = settings.shadows;

    this.ambient = new AmbientLight(0x8899aa, 0.9);

    this.object3D.add(this.sun, this.sun.target, this.ambient);
  }

  dispose(): void {
    this.sun.dispose();
    this.ambient.dispose();
    this.object3D.clear();
  }
}
